// Replaces `@shopify/app-bridge-utils`'s `isMobile`/`isShopifyEmbedded` (v3
// package, no v4 successor — removed in the 2026-07 migration). Logic copied
// verbatim from that package's `utilities/platform.js` + app-bridge's
// `util/env.js` so behavior is unchanged; only the App Bridge v3 dependency
// is gone.

const isClient = typeof window !== 'undefined';

function isUnframed() {
  return !!(isClient && window.navigator?.userAgent?.indexOf('Unframed') > 0);
}

function isShopifyMobile() {
  return typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Shopify Mobile') >= 0;
}

function isShopifyPOS() {
  return typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Shopify POS') >= 0;
}

function isShopifyPing() {
  return typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Shopify Ping') >= 0;
}

export function isMobile() {
  return isShopifyMobile() || isShopifyPOS() || isShopifyPing();
}

export function isShopifyEmbedded() {
  return (isClient && window.top !== window.self) || isUnframed();
}
